import { Box } from "@mui/material";
import React, { useEffect } from "react";
import DatabaseNavigatorRightTop from "./DatabaseNavigatorRightTop";
import DatabaseNavigatorRightBottom from "./DatabaseNavigatorRightBottom";
import Split from "react-split";

const DatabaseNavigatorRight = ({
  showQuery,
  setConnectionLoading,
  connection,
  setConnection,
  encoding,
  setEncoding,
  schema,
  setSchema,
  selectedTable,
  setSelectedTable,
  sort,
  setSort,
  sqlQuery,
  setSqlQuery,
  setSqlActions,
  sqlActions,
  currTabTop,
  currTabBottom,
  setCurrTabTop,
  setCurrTabBottom,
  selectedMetaData,
  setSelectedMetaData,
  sqlEditorRef,
  templateQuery,
  prepend,
  setPrepend,
  selectedCompareSQL,
  setSelectedCompareSQL,
  showAlert
}) => {


  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        margin: "auto",
      }}
    >
      <Split
        style={{ height: "100%" }}
        className="split border-container"
        direction="vertical"
        sizes={[35, 65]}
        gutterSize={4}
        snapOffset={0}
        dragInterval={4}
      >
        <Box className="height-100 ">
          <DatabaseNavigatorRightTop 
            showQuery={showQuery}
            setConnectionLoading={setConnectionLoading}
            connection={connection}
            setConnection={setConnection}
            schema={schema}
            setSchema={setSchema}
            encoding={encoding}
            setEncoding={setEncoding}
            selectedTable={selectedTable}
            setSelectedTable={setSelectedTable}
            sqlQuery={sqlQuery}
            setSqlQuery={setSqlQuery}
            setSqlActions={setSqlActions}
            setCurrTab={setCurrTabTop}
            currTab={currTabTop}
            sqlEditorRef={sqlEditorRef}
            templateQuery={templateQuery}
            setCurrTabBottom={setCurrTabBottom}
          />
        </Box>
        <Box className="height-100">
          <DatabaseNavigatorRightBottom 
            showQuery={showQuery}
            showAlert={showAlert}
            setConnectionLoading={setConnectionLoading}
            connection={connection}
            setConnection={setConnection}
            schema={schema}
            setSchema={setSchema}
            encoding={encoding}
            setEncoding={setEncoding}
            selectedTable={selectedTable}
            setSelectedTable={setSelectedTable}
            sort={sort}
            setSort={setSort}
            sqlQuery={sqlQuery}
            setSqlQuery={setSqlQuery}
            setSqlActions={setSqlActions}
            sqlActions={sqlActions}
            setCurrTab={setCurrTabBottom}
            currTab={currTabBottom}
            selectedMetaData={selectedMetaData}
            setSelectedMetaData={setSelectedMetaData}
            setCurrTabTop={setCurrTabTop}
            templateQuery={templateQuery}
            prepend={prepend}
            setPrepend={setPrepend}
            selectedCompareSQL={selectedCompareSQL}
            setSelectedCompareSQL={setSelectedCompareSQL}
          />
        </Box>
      </Split>
    </Box>
  );
};

export default DatabaseNavigatorRight;
